import type {AxiosRequestConfig} from 'axios';
import {Status, User} from '../users/interface';

export class GetProvidersBuilder {
  private readonly providerRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/providers/',
    params: {},
  };

  params(params: object) {
    this.providerRequest.params = params;
    return this;
  }

  build() {
    return this.providerRequest;
  }
}

export class GetProvidersCountBuilder {
  private readonly providerRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/providers/count',
    params: {},
  };

  params(params: object) {
    this.providerRequest.params = params;
    return this;
  }

  build() {
    return this.providerRequest;
  }
}

export class UpdateProviderStatusRequestBuilder {
  private readonly request: AxiosRequestConfig = {
    method: 'PUT',
    url: '',
    data: {},
  };

  id(id: number) {
    this.request.url = `/providers/${id}/status`;
    return this;
  }

  data(body: Status) {
    this.request.data = `"${body}"`;
    return this;
  }

  build() {
    return this.request;
  }
}

export class CreateProviderRequestBuilder {
  private readonly request: AxiosRequestConfig = {
    method: 'POST',
    url: '/providers/',
    data: {},
  };

  data(data: User) {
    this.request.data = data;
    return this;
  }

  build() {
    return this.request;
  }
}
